<template>
  <div class="ds-empty-state">
    <v-icon class="ds-empty-state__icon">mdi-bullhorn-outline</v-icon>
    <div class="ds-empty-state__title">Release Notes isn't enabled yet</div>
    <div class="ds-empty-state__description">
      The Release Notes feature is currently turned off for this environment. An administrator needs
      to enable it before releases can be created, generated or published.
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ReleaseNotesDisabledNotice',
  };
</script>
